export const PAYMENT_PACKAGES = {
  SET_CURRENT_PAYMENT_PACKAGE: 'SET_CURRENT_PAYMENT_PACKAGE',
  FETCH_ALL_PAYMENT_PACKAGES_REQUEST: 'FETCH_ALL_PAYMENT_PACKAGES_REQUEST',
  FETCH_ALL_PAYMENT_PACKAGES_SUCCESS: 'FETCH_ALL_PAYMENT_PACKAGES_SUCCESS',
  FETCH_ALL_PAYMENT_PACKAGES_FAIL: 'FETCH_ALL_PAYMENT_PACKAGES_FAIL'
};
